var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestmentsInactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invest_NavIcon_VerNet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invest_NavIcon_VerNet_2",
    clipPath: "url(#clip0_1112_70708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5 19.03H19.17V3.5C19.17 3.22 18.95 3 18.67 3H16.05C15.77 3 15.55 3.22 15.55 3.5V19.03H13.55V6.02C13.55 5.74 13.33 5.52 13.05 5.52H10.43C10.15 5.52 9.93 5.74 9.93 6.02V19.03H7.93V9.95C7.93 9.67 7.71 9.45 7.43 9.45H4.81C4.53 9.45 4.31 9.67 4.31 9.95V19.04H2.5C2.22 19.04 2 19.27 2 19.54C2 19.81 2.23 20.04 2.5 20.04H21.49C21.77 20.04 21.99 19.81 21.99 19.54C21.99 19.27 21.76 19.04 21.49 19.04L21.5 19.03Z",
    fill: "#8F91A1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_70708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.04,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsInactiveIcon);
export default __webpack_public_path__ + "static/media/investments-inactive-icon.f0a76e1f7db1cabf5c03ccf643465732.svg";
export { ForwardRef as ReactComponent };